import React from "react";
import { useTemplate3Context } from "repoV2/pages/sale/templates/Template3/Template3Context";
import { getFixedLengthNumString } from "repoV2/utils/common/dataTypes/string";
import { classNames } from "repoV2/utils/common/render/classNames";
import { FULL_TIME_UNITS } from "repoV2/features/Common/modules/DateTime/modules/Time/Time.constants";
import { IGetCountdownTimerReturnUnits } from "repoV2/utils/common/time/countDownTimer";
import styles from "./CountdownTimer.module.scss";

export const CountdownTimer = ({
    units,
}: {
    units: IGetCountdownTimerReturnUnits;
}) => {
    const { theme } = useTemplate3Context();

    return (
        <div
            className={classNames(styles.timerContainer, "d-flex")}
            style={{ color: theme.colors.color11 }}
        >
            {units.map(unit => (
                <div
                    className={classNames(
                        styles.timeUnit,
                        "d-flex flex-column align-items-center justify-content-center"
                    )}
                    style={{ backgroundColor: theme.colors.color3 }}
                    key={unit.unit}
                >
                    <div className={styles.timeUnitText}>
                        {getFixedLengthNumString(unit.value)}
                    </div>
                    <div className={styles.timerUnitDesc}>
                        {FULL_TIME_UNITS[unit.unit].toUpperCase()}
                    </div>
                </div>
            ))}
        </div>
    );
};
